import React, { FC } from "react";
import dynamic from "next/dynamic";
import { ControllerRenderProps } from "react-hook-form";
import { CheckBox } from "@mui/icons-material";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import withStyles from "@mui/styles/withStyles";
import { UseFormStateReturn } from "react-hook-form/dist/types";

const StyledToggleButton = withStyles({
  selected: {
    color: "#00a0d1 !important",
    backgroundColor: "rgba(230, 251, 255, 0.5) !important",
    fontWeight: 700,
    borderColor: "#00a0d1 !important",
  },
  root: {
    padding: "8px 0px",
    color: "#121212",
    border: "1px solid #DEDEDE",
    borderRadius: "4px !important",
    "&:not(.Mui-selected)": {
      borderColor: "#DEDEDE !important",
    },
  },
})(ToggleButton);

const useStyles = makeStyles(() => ({
  checkbox: {
    display: "none",
    position: "absolute",
    top: -2,
    right: -2,
    fontSize: "0.85rem",
    borderRadius: 4,
    ".Mui-selected &": {
      display: "block",
    },
  },
}));
const QVRDialogNextDate: FC<ControllerRenderProps & UseFormStateReturn<any>> = (props) => {
  const classes = useStyles();

  return (
    <>
      <ToggleButtonGroup
        {...props}
        onChange={(_e, v) => {
          v && props.onChange(v);
        }}
        exclusive={true}
      >
        <StyledToggleButton
          value="Led"
          style={{ width: 134, justifyContent: "center" }}
        >
          <span
            style={{
              fontSize: 12,
              display: "flex",
              alignItems: "center",
            }}
          >
            Led
            <CheckBox className={classes.checkbox} />
          </span>
        </StyledToggleButton>
        <StyledToggleButton
          value="Participated In"
          style={{
            marginLeft: 12,
            width: 134,
            justifyContent: "center",
          }}
        >
          <span
            style={{
              fontSize: 12,
              display: "flex",
              alignItems: "center",
            }}
          >
            Participated In
            <CheckBox className={classes.checkbox} />
          </span>
        </StyledToggleButton>
        <StyledToggleButton
          value="Just Attended"
          style={{
            marginLeft: 12,
            width: 134,
            justifyContent: "center",
          }}
        >
          <span
            style={{
              fontSize: 12,
              display: "flex",
              alignItems: "center",
            }}
          >
            Just Attended
            <CheckBox className={classes.checkbox} />
          </span>
        </StyledToggleButton>
      </ToggleButtonGroup>
      {!!props.errors?.[props.name] && (
        <p style={{ color: "#f44336" }}>{props.errors?.[props.name]?.message}</p>
      )}
    </>
  );
};

export default dynamic(() => Promise.resolve(QVRDialogNextDate), {
  ssr: false,
});
